import { createTheme, rem } from '@mantine/core';

export const theme = createTheme({
    fontFamily:
        'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    headings: {
        fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontWeight: '650',
    },
    primaryColor: 'blue',
    primaryShade: 7,
    defaultRadius: 'md',
    cursorType: 'pointer',
    colors: {
        brand: [
            '#E8EEF5',
            '#C5D4E8',
            '#9FB8D6',
            '#789BC4',
            '#527EB2',
            '#3A6496',
            '#2A4A72',
            '#0E2038',
            '#0A1829',
            '#06101A',
        ],
    },
    components: {
        Button: {
            defaultProps: { radius: 'md' },
        },
        Card: {
            defaultProps: { radius: 'lg', withBorder: true },
        },
        TextInput: {
            defaultProps: { size: 'md' },
        },
        Textarea: {
            defaultProps: {
                size: 'md',
                autosize: true,
                minRows: 2,
            },
        },
        PasswordInput: {
            defaultProps: { size: 'md' },
        },
        Select: {
            defaultProps: { size: 'md' },
        },
        /** CRM-style segmented navigator — visual styles in admin.css. */
        Tabs: {
            defaultProps: {
                variant: 'pills',
                radius: 'md',
            },
        },
    },
    fontSizes: {
        md: rem(15),
    },
});
